// extracted by mini-css-extract-plugin
export default {"section":"quote-module--section--A4Z1I"};